<template>
    <ul class="mainmenu">
		<li><router-link to="/">首页</router-link></li>
        
        <li class="with-megamenu has-menu-child-item ">
            <a href="#">
                平台
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <div style="height:3px; opacity:0.1"></div>
            <div class="rn-megamenu">
                <div class="content">
                    <div class="menu-item-left row--0">
                        <div class="menu-item-left-text">
                            <div class="title">平台介绍</div>
                            <div class="description">通过博信诚智慧创新ECOP平台与元生AI平台助力企业搭建各类高效、高精度的AI应用</div>
                            <div class="link">立刻前往 ></div>
                        </div>
                    </div>
                    <div class="menu-item-right ">
                        <div class="menu-item-right-text">
                            <div class="rn-footer-widget">
                                <h4 class="title">平台</h4>
                                <div class="inner">
                                    <ul class="footer-link link-hover">
                                        <li>
                                            <router-link to="/ai-page">元生AI平台</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/home">BossinMind 博信诚一站式AI大模型</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/ecop-page">智慧创新平台ECOP</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="menu-item-right-img">
                            <div>
                                <img src="@/assets/newImages/nav/平台_图1@2x.png" alt="">
                                <div class="link">了解更多></div>
                            </div>
                            <div>
                                <img src="@/assets/newImages/nav/平台_图2@2x.png" alt="">
                                <div class="link">了解更多></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
        <li class="with-megamenu has-menu-child-item ">
            <a href="#">
                产品及解决方案
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <div style="height:3px; opacity:0.1"></div>
            <div class="rn-megamenu">
                <div class="content">
                    <div class="menu-item-left row--0">
                        <div class="menu-item-left-text">
                            <div class="title">产品及解决方案</div>
                            <div class="description">博信诚拥有面向大型集团的元生AI平台、企业AI、医疗AI、BossinMind行业及企业专属大模型等核心产品及解决方案助力企业战略可持续性发展，推动业务增长和盈利能力</div>
                            <div class="link">立刻前往 ></div>
                        </div>
                    </div>
                    <div class="menu-item-right ">
                        <div class="menu-item-right-text">
                            <div>
                                <div class="rn-footer-widget">
                                    <h4 class="title">企业AI</h4>
                                    <div class="inner">
                                        <ul class="footer-link link-hover">
                                            <li>
                                                <router-link to="/product-solution/1">BossinData数据智能体平台</router-link>
                                            </li>
                                            <li>
                                                <router-link to="/product-solution/2">智审通 | AI审核平台</router-link>
                                            </li>
                                            <li>
                                                <router-link to="/product-solution/3">AI智慧网银</router-link>
                                            </li>
                                            <li>
                                                <router-link to="/product-solution/4">EECloud大企业业财一体化AI</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="rn-footer-widget">
                                    <h4 class="title">医疗AI</h4>
                                    <div class="inner">
                                        <ul class="footer-link link-hover">
                                            <li>
                                                <router-link to="/product-solution/5">医鉴通 | 医嘱与病历审核质控智能体</router-link>
                                            </li>
                                            <li>
                                                <router-link to="/product-solution/6">医院AI审核</router-link>
                                            </li>
                                            <li>
                                                <router-link to="/product-solution/7">医院收入运营数据智能体</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="menu-item-right-img">
                            <div>
                                <img src="@/assets/newImages/nav/产品解决方案_图3@2x.png" alt="">
                                <div class="link">了解更多></div>
                            </div>
                            <div>
                                <img src="@/assets/newImages/nav/产品解决方案_图4@2x.png" alt="">
                                <div class="link">了解更多></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
        <li class="with-megamenu has-menu-child-item ">
            <a href="#">
                行业实践
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <div style="height:3px; opacity:0.1"></div>
            <div class="rn-megamenu">
                <div class="content">
                    <div class="menu-item-left row--0">
                        <div class="menu-item-left-text">
                            <div class="title">行业实践</div>
                            <div class="description">通过博信诚全栈智能体产品与场景化解决方案，沉浸式体验覆盖央国企、医疗健康、智能制造、公共交通等行业的AI智能体应用。</div>
                            <div class="link">立刻前往 ></div>
                        </div>
                    </div>
                    <div class="menu-item-right ">
                        <div class="menu-item-right-text">
                            <div>
                                <div class="rn-footer-widget">
                                    <h4 class="title">医疗行业</h4>
                                    <div class="inner">
                                        <ul class="footer-link link-hover">
                                            <li>
                                                <router-link to="/industry-practice/1">医院AI审核</router-link>
                                            </li>
                                            <li>
                                                <router-link to="/industry-practice/1">医嘱与病历审核质控智能体</router-link>
                                            </li>
                                            <li>
                                                <router-link to="/industry-practice/1">医院收入运营数据智能体</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="rn-footer-widget">
                                    <h4 class="title">国资行业</h4>
                                    <div class="inner">
                                        <ul class="footer-link link-hover">
                                            <li>
                                                <router-link to="/industry-practice/0">AI穿透式监管方案</router-link>
                                            </li>
                                            <li>
                                                <router-link to="/industry-practice/2">基于财务共享的AI风控审核方案</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
    
                            </div>
                        </div>
                        
                        <div class="menu-item-right-img">
                            <div>
                                <img src="@/assets/newImages/nav/行业实践_图5@2x.png" alt="">
                                <div class="link">了解更多></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
        <li class="with-megamenu has-menu-child-item ">
            <a href="#">
                关于我们
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <div style="height:3px; opacity:0.1"></div>
            <div class="rn-megamenu">
                <div class="content">
                    <div class="menu-item-left row--0">
                        <div class="menu-item-left-text">
                            <div class="title">关于我们</div>
                            <div class="description">博信诚助力AI转型和构建智慧企业的服务商，10余年专注为中高端客户提供全场景、一站式的智能化服务。</div>
                            <div class="link">立刻前往 ></div>
                        </div>
                    </div>
                    <div class="menu-item-right ">
                        <div class="menu-item-right-text">
                            <div class="rn-footer-widget">
                                <h4 class="title">关于我们</h4>
                                <div class="inner">
                                    <ul class="footer-link link-hover">
                                        <li>
                                            <router-link to="/about-us?id=1">关于博信诚</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/about-us?id=2">荣誉和资质</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/about-us?id=3">支持与服务</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/about-us?id=4">新闻动态</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/about-us?id=5">加入我们</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                        <div class="menu-item-right-img">
                            <div>
                                <img src="@/assets/newImages/nav/关于我们_图6@2x.png" alt="">
                                <div class="link">了解更多></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
       
    </ul>
</template>

<script>
    import Icon from "../../icon/Icon";
    export default {
        name: 'Nav',
        components: {Icon}
    }
</script>